import styled from "styled-components";
import { deviceSizesMin } from "../../../DeviceSizes";

export const StoreContainer = styled.div`
  width: 90%;
  margin: auto;

  @media only screen and ${deviceSizesMin.laptopL} {
    width: 1200px;
  }
`;
